import React, { Component } from "react"
import {
  Segment,
  Form,
  Header,
  Icon,
  Divider,
  Button,
} from "semantic-ui-react";
import feathers from "../../../feathers-client";
import swal from "sweetalert";
import md5 from "md5";

const INITIAL_DATA = {
  full_name: "",
  username: "",
  clase_id: 0,
  rol: "Maestro",
  password: ""
}
const ROLES_DATA = [
  {
    key: 0,
    text: "Maestro",
    value: "Maestro"
  },
  {
    key: 1,
    text: "Director",
    value: "Director"
  }
]

class CreateMaestro extends Component {
  state = {
    loading: false,
    clasesLoading: true,
    user: INITIAL_DATA,
    clases: [],
    roles: ROLES_DATA
  }

  componentDidMount() {
    this.getClases();
  }

  getClases = () => {
    const clases = feathers.service("clases");
    clases.find({
      query: {
        $limit: 1000
      }
    })
      .then(res => {
        const clases = res.data.map((c, i) => ({
          key: i,
          text: c.name,
          value: c.id
        }))
        this.setState({clases, clasesLoading: false})
      })
  }

  handleChange = (e) => {
    this.setState({
      user: {
        ...this.state.user,
        [e.target.name]: e.target.value
      },
    });
  };

  handleChangeSelect = (event, result) => {
    const { name, value } = result || event.target;
    this.setState({
      user: {
        ...this.state.user,
        [name]: value
      }
    });
  };

  handleSubmit = async () => {
    this.setState({ loading: true });
    const newUser = {...this.state.user}
    newUser.password = md5(newUser.password)
    await feathers
      .service("users")
      .create(newUser)
      .then(res => {
        console.log(res);
        swal(
          "Clase Agregada",
          "La clase se ha agregado correctamente",
          "success",
          {timer: 1500}
        );
        this.setState({
          user: INITIAL_DATA,
          loading: false
        });
      })
      .catch(err => {
        console.log(err);
        swal(
          "Error",
          "Ha ocurrido un error. Por favor intente mas tarde",
          "error"
        );
        this.setState({ loading: false });
      });
  };

  render() {
    return (
     <Segment loading={this.state.loading}>
       <Header as="h1">
          <Icon name="plus" size="large" />
          <Header.Content>Agregar Maestro</Header.Content>
        </Header>
        <Divider />
        <Form style={{ textAlign: "left"}}>
          <Form.Group widths="equal">
            <Form.Input
              required
              fluid
              name="full_name"
              label="Nombre del Maestro"
              value={this.state.user.full_name}
              onChange={this.handleChange}
            />
            <Form.Input
              required
              fluid
              name="username"
              label="Usuario del Maestro"
              value={this.state.user.username}
              onChange={this.handleChange}
            />
            <Form.Input
              required
              fluid
              type="password"
              name="password"
              label="Contraseña:"
              value={this.state.user.password}
              onChange={this.handleChange}
            />
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Select
              required
              fluid
              label="Clase:"
              value={this.state.user.clase_id}
              name="clase_id"
              options={this.state.clases}
              onChange={this.handleChangeSelect}
            />
            <Form.Select
              required
              fluid
              label="Rol:"
              value={this.state.user.rol}
              name="rol"
              options={this.state.roles}
              onChange={this.handleChangeSelect}
            />
          </Form.Group>
          <Button
            disabled={
              this.state.user.full_name === "" ||
              this.state.user.username === "" ||
              this.state.user.password === "" || 
              this.state.user.clase_id === 0
            }
            primary content="Registrar" 
            onClick={this.handleSubmit} 
          />
        </Form>
     </Segment>
    )
  }
}

export default CreateMaestro;
